export enum CONNECTOR_TYPE {
  Type1 = 'Type1',
  Type2 = 'Type2',
  CCS = 'CCS',
  CHAdeMO = 'CHAdeMO',
}
